import React from 'react';
import { History } from 'history';
import { Button, Card, Logo, PageSection, Table } from '../../components';
import AppModel from '../app/app-model';
import OwnerModel from '../owner/owner-model';
import UserModel from '../user/user-model';
import SectionModel from '../section/section-model';
import BaseView from '../base/base-view.component';
import ProductgroupListProduct from '../productgroup/productgroup-list-product.component';
import AddressPicklistCard from '../address/address-picklistcard.component';
import AppService from '../../services/app.service';

interface IProps {
  history: History;
  id?: number;
  onLoad?: (data: any) => void;
  disableAppbar?: boolean;
}

interface IState {
  datarow: any;
  datarowApp: AppModel;
  datarowOwner: OwnerModel;
  transitionPlay: boolean;
}

export default class SectionViewPublic extends React.Component<IProps, IState> {
  
  constructor(props: IProps) {
    super(props);
    this.state = {
      datarow: null,
      datarowApp: AppModel.defaultValue(),
      datarowOwner: OwnerModel.defaultValue(),
      transitionPlay: true,
    }
  }

  private historyState: any = this.props.history.location.state;
  private isMobile: boolean = AppService.isMobile();
  
  private sectionUpdate(data: any) {
    const menu = data?.section?.map((d: any) => ({section: d.id, ...d.menu})).filter((d: any) => !!d.caption);
    const avatar = this.state.datarowOwner?.personalinfoLength > 0 && {name: UserModel.getUserCaption(), imageUrl: UserModel.getUserImageUrl(), onClick: this.onClickAvatar}    
    const actionHeader = data?.section?.filter((d1: any) => d1.type === 'header')?.[0]?.action || 'sectionProduct';
    const appbar = !this.props.disableAppbar && {menu: menu, avatar: avatar, logoCaption: data?.appbar?.logoCaption};

    const caption = [
      {id: 0, text: '', size: 'superlarge', textToHtml: true, bold: true, lineHeight: this.isMobile? 1.2 : 1.4, marginTop: 0, marginBottom: 0}, 
      {id: 1, text: '', size: 'large', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 2, text: '', color: 'primary.main', size: 'extralarge', textToHtml: true, bold: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 5, marginBottom: 0}, 
      {id: 3, text: '', size: 'large', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 4, text: '', color: 'primary.main', size: 'extralarge', textToHtml: true, bold: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 5, marginBottom: 0}, 
      {id: 5, text: '', size: 'large', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 6, text: '', color: 'primary.main', size: 'extralarge', textToHtml: true, bold: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 5, marginBottom: 0}, 
      {id: 7, text: '', size: 'large', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 8, text: '', color: 'primary.main', size: 'extralarge', textToHtml: true, bold: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 5, marginBottom: 0}, 
      {id: 9, text: '', size: 'large', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 10, text: '', color: 'primary.main', size: 'extralarge', textToHtml: true, bold: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 5, marginBottom: 0}, 
      {id: 11, text: '', size: 'large', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
    ];
    const captionList = [
      {id: 0, text: '', color: 'white', size: 'superlarge', textToHtml: true, bold: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 0, marginBottom: 0}, 
      {id: 1, text: '', color: 'white', size: 'large', 'icon': 'check_circle', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 2, text: '', color: 'white', size: 'large', 'icon': 'check_circle', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 3, text: '', color: 'white', size: 'large', 'icon': 'check_circle', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 4, text: '', color: 'white', size: 'large', 'icon': 'check_circle', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 5, text: '', color: 'white', size: 'large', 'icon': 'check_circle', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 6, text: '', color: 'white', size: 'large', 'icon': 'check_circle', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 7, text: '', color: 'white', size: 'large', 'icon': 'check_circle', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 8, text: '', color: 'white', size: 'large', 'icon': 'check_circle', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 9, text: '', color: 'white', size: 'large', 'icon': 'check_circle', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
      {id: 10, text: '', color: 'white', size: 'large', 'icon': 'check_circle', textToHtml: true, lineHeight: this.isMobile? 1.2 : 1.1, marginTop: 2, marginBottom: 0}, 
    ];
    const captionHeader = caption.map((d: any) => d.id === 0? {...d, size: 'superextralarge'} : d);
    const captionQNA = caption.map((d: any) => d.id < 2? d : {...d, size: (d.id % 2) === 0? 'large' : 'medium'} );
    const sections = [
      {type: 'header', color: 'background.paper', trapezoid: 'bottomLeft', align: '', position: '', fullHeight: false, maxWidth: 'md', transition: {type: 'grow', play: true}, background: {image: '', size: 'cover'},
        content: [
          {id: 0, caption: captionHeader, marginTop: 7},
          {id: 1, child: <Button type='contained' label='' textTransform='capitalize' onClick={() => document.getElementById(actionHeader)?.scrollIntoView(true)}/> , marginTop: 5, },
          {id: 2, child:
              <Card>
                <Table header={null} dataset={null} cardCount={3} cardView cardAlign='center' cardBorderWidth={0} swipe='horizontal' onLoad={(d) => AppService.openLink(d.linkPath)} isReady readOnly />
              </Card>
          , marginTop: 5, marginBottom: 20}
        ]
      },

      {type: 'general', color: 'white', align: '', position: '', fullHeight: false, maxWidth: '', transition: {type: 'grow', play: this.state.transitionPlay}, 
        content: [ {id: 0, caption: caption} ]
      },

      {type: 'list', color: 'primary.dark', align: '', position: '', fullHeight: false, transition: {type: 'grow', play: this.state.transitionPlay}, 
        content: [ {id: 0, caption: captionList} ]
      },

      {type: 'qna', color: 'white', align: '', position: '', fullHeight: false, maxWidth: '', transition: {type: 'grow', play: this.state.transitionPlay}, 
        content: [ {id: 0, caption: captionQNA} ]
      },

      {type: 'gallery', color: 'primary.light', align: '', position: '', fullHeight: false, maxWidth: '', transition: {type: 'grow', play: this.state.transitionPlay},
        content: [ {id: 0, caption: caption, captionPosition: '', child: <Table header={null} dataset={null} cardCount={6} cardView swipe='horizontal' onLoad={(d) => AppService.openLink(d.linkPath)} isReady readOnly />} ]
      },

      {type: 'product', color: 'white', align: '', position: '', fullHeight: false, maxWidth: '', transition: {type: 'growLeft', play: this.state.transitionPlay},
        content: [ {id: 0, caption: caption, captionPosition: '', child: <ProductgroupListProduct history={this.props.history} onLoad={this.onLoadProduct} /> } ]
      },

      {type: 'footer', color: 'secondary.light', align: '', position: '', fullHeight: false, maxWidth: 'lg', trapezoid: 'topLeft', transition: {type: 'growLeft', time: 200, play: this.state.transitionPlay},
        content: [
          {id: 0, caption: [
              {id: 0, text: this.state.datarowApp.description, size: 'medium', color:'primary.dark', marginTop: 2}, 
              {id: 1, text: this.state.datarowOwner.description, size: 'medium', bold: true, color:'primary.dark', marginTop: 5}, 
              {id: 2, text: this.state.datarowOwner.address, size: 'medium', color:'primary.dark'},
              {id: 3, text: this.state.datarowOwner.phone, color: 'primary.main', size: 'small', icon: 'phone', iconSize:'small', url: this.state.datarowOwner.phone && 'https://api.whatsapp.com/send?text=&phone=' +AppService.strPhoneToNumber(this.state.datarowOwner.phone), marginTop: 1},
              {id: 4, text: this.state.datarowOwner.email, color: 'primary.main', size: 'small', icon: 'email', iconSize:'small', url: this.state.datarowOwner.email && 'mailto:' +this.state.datarowOwner.email, marginTop: 1},
              {id: 5, marginTop: 5},
              ], 
            captionPosition: 'bottom',
            columnSize: 5, 
            child: <Logo label={data?.appbar?.logoCaption}/>
            },  
          {id: 1, caption: [
            {id: 0, text: 'Informasi', size: 'medium', bold: true, marginTop: 5}, 
            ]
            .concat(menu?.map((d: any, i: number) => ({id: i, text: d.caption, color:'primary.main', size: 'small', marginTop: 1}))),
            columnSize: 3
            }, 
          {id: 2, caption: [
            {id: 0, text: 'Ikuti kami', size: 'medium', bold: true, marginTop: 5}
            ],
            columnSize: 4,
            child: <AddressPicklistCard history={this.props.history} caption=' ' parentType='app' parentId={+AppService.appId()} cardIconOnly onLoad={(d) => AppService.openLink(d.linkPath)}/>,
            }
        ]
      }  
    ];
    const sectionsUpdate = data.section?.map((d: any, i: number) =>
      AppService.mergeArray({id: d.id, seq: i, ...sections.filter((d1: any) => d1.type === d.type)?.[0]}, d)
    );
    
    this.props.onLoad?.({ appbar: appbar, maxWidth: data?.maxWidth});
    this.setState({datarow: sectionsUpdate});
  }

  private onLoadApp = (data: any) => {
    this.setState({datarowApp: data})
  }

  private onLoadOwner = (data: any) => {
    this.setState({datarowOwner: data})
  }

  private onLoadSection = (data: any) => {
    this.sectionUpdate(data?.option);
  }

  private onLoadProduct = (data: any) => {
    AppService.historyState('sectionId', 'sectionProduct');
    this.props.history.push('/product', {id: data.id});
  }

  private onClickAvatar = () => {
    this.props.history.replace({}, {authSignin: !UserModel.isSignin(), nextUrl: AppService.pathDashboard});
  }
  
  public componentDidUpdate() {
    document.getElementById(this.historyState?.sectionId)?.scrollIntoView(true);
    AppService.historyState('sectionId', '', true);
  }

  public render(): React.ReactNode {
    return (
      <>
        <BaseView id={+AppService.appId()}
          model={AppModel} onLoad={this.onLoadApp}/>
        
        <BaseView id={0}
          model={OwnerModel} endPointFilter={OwnerModel.endPointFilter()} onLoad={this.onLoadOwner}/>
        
        {!!this.props.id &&
        <BaseView id={this.props.id}
          model={SectionModel} onLoad={this.onLoadSection}/>
        }
        
        <PageSection section={this.state.datarow}/>
      </>
    )
  }
}